import React from 'react';
import { Button, ButtonProps } from '@/components/atoms/Button';
import { DropDown } from '@/components/atoms/DropDown';
import { DropDownText } from '@/components/atoms/DropDown/DropDown.type';
import { Container } from './ActionDropdownCell.style';

export type ActionDropdownCellProps = {
    action: ButtonProps & Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>;
    dropdown: DropDownText<unknown>;
};

export const ActionDropdownCell: React.FunctionComponent<ActionDropdownCellProps> = ({ action, dropdown }) => {
    return (
        <Container onClick={(e) => e.stopPropagation()}>
            <Button {...action} />
            <DropDown {...dropdown} />
        </Container>
    );
};
